import Swal from 'sweetalert2'

/*
alert 관련 메시지 이벤트 저장 후 사용
 */

export default {
    methods: {
        createAlert(params){
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.btnText ? '확인' : params.btnText,
                customClass: !params.customClass ? 'alert-default' : params.customClass,
                didClose: () => {
                    if(params.back){
                        window.history.back();
                    }else if(params.hide) {
                        params.hide();
                    }
                }
            })
        },
        createConfirm(params){
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.confirmText ? '확인' : params.confirmText,
                cancelButtonText: !params.cancelText ?'취소' : params.cancelText,
                showCancelButton: true,
                customClass: !params.customClass ? 'alert-default' : params.customClass,
                allowOutsideClick: params.allowOutsideClick ?? true,
                allowEscapeKey: params.allowEscapeKey ?? true,
                // showCloseButton: true,
                // allowOutsideClick: false,
            }).then((result) => {
                if (result.value) {
                    if(params.confirm)
                        params.confirm();
                } else if(result.dismiss === 'cancel') {
                    if(params.cancel)
                        params.cancel();
                }
            })
        },

        errorAlert(params){
            const title = typeof params === 'object' && params !== null ? params.title : '';
            const content = typeof params === 'object' && params !== null ? params.content : params;
            const customClass = typeof params === 'object' && params !== null ? params.customClass : '';

            Swal.fire({
                title: title || '',
                html: content || '',
                confirmButtonText: '확인',
                customClass: !customClass ? 'alert-default' : customClass,
                didClose: () => {

                }
            })
        },
        inputAlert(params) {
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                input: 'text',
                inputPlaceholder:!params.placeHolder ? '' : params.placeHolder,
                confirmButtonText: !params.confirmText ? "확인" : params.confirmText,
                cancelButtonText: !params.cancelText ? "취소" : params.cancelText,
                showCancelButton: true,
                customClass: !params.customClass ? 'alert-default' : params.customClass,
            }).then((result) => {
                if (!result.dismiss) {
                    if (params.confirm) {
                        params.confirm(result.value);
                    }
                } else {
                    if (params.cancel) {
                        params.cancel();
                    }
                }
            })
        },
    }
}
